import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { ScreenService } from '../../../services/screen.service';

@Component({
  selector: 'dk-left-side-panel',
  templateUrl: './left-side-panel.component.html',
  styleUrls: ['./left-side-panel.component.scss'],
  standalone: true,
  imports: [DxButtonModule, DxScrollViewModule, CommonModule],
})
export class LeftSidePanelComponent {
  isSmallScreen = false;
  isOpened = !(
    this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small']
  );

  constructor(protected screen: ScreenService) {
    screen.smallScreenChanged.subscribe((isSmall) => {
      this.isSmallScreen = isSmall;

      if (!isSmall) {
        this.isOpened = true;
      }
    });
  }

  toggleOpen = () => {
    this.isOpened = !this.isOpened;
  };
}
